/*
  Odnosnik do wpisu na Instagramie w oknie aplikacji Instafeed.

  Okno wpisu (.instafeed-lightbox) rysuje aplikacja i domyslnie NIE ma w nim
  zadnego odnosnika do samego wpisu: w naglowku jest wylacznie link do profilu,
  a zdjecie ma ustawione pointer-events: none, wiec klikniecie nic nie robi.
  Wbudowana opcja aplikacji ("instagramLinks", w jej wlasnym panelu) dolozylaby
  tam maly odnosnik tekstowy przy nazwie profilu i po angielsku - dlatego robimy
  to po naszej stronie: klikalne zdjecie plus przycisk w jezyku sklepu.

  Adres wpisu bierzemy z TEGO SAMEGO zapytania, ktore aplikacja juz wykonala
  (api.nfcube.com/feed) - adres wyciagamy z listy zasobow wczytanych przez strone,
  wiec nie ma tu zaszytego klucza sklepu ani numeru wersji API i nic nie trzeba
  poprawiac, gdy aplikacja je zmieni. Gdy zapytanie zawiedzie, przycisk prowadzi
  na profil, a nie znika.

  Numer wpisu siedzi w identyfikatorze okna ("<id>-insta-feed") i to on wiaze
  okno z pozycja z zapytania.
*/
if (!window.cossyInstagramPostLink) {
  window.cossyInstagramPostLink = true;

  (() => {
    const ZNACZNIK = "cossyPostLink";
    const adresyWpisow = new Map();
    const udekorowane = [];

    const etykieta = () => {
      const sekcja = document.querySelector("instagram-carousel[data-post-link-label]");
      return (sekcja && sekcja.dataset.postLinkLabel) || "";
    };

    const adresProfilu = (okno) => {
      const profil = okno.querySelector("a.follow[href]");
      return profil ? profil.href : "";
    };

    // adres zapytania o feed - ten sam, ktorego uzyla aplikacja
    const adresFeedu = () =>
      performance
        .getEntriesByType("resource")
        .map((wpis) => wpis.name)
        .find((nazwa) => nazwa.indexOf("api.nfcube.com/feed/") !== -1);

    const pobierzAdresy = async () => {
      const adres = adresFeedu();
      if (!adres) return false;

      try {
        const odpowiedz = await fetch(adres, { credentials: "omit" });
        if (!odpowiedz.ok) return false;
        const dane = await odpowiedz.json();
        (dane.data || []).forEach((wpis) => {
          if (wpis && wpis.id && wpis.link) adresyWpisow.set(String(wpis.id), wpis.link);
        });
        return adresyWpisow.size > 0;
      } catch (blad) {
        return false;
      }
    };

    const adresDlaOkna = (okno) => {
      const numer = (okno.id || "").replace(/-insta-feed$/, "");
      return adresyWpisow.get(numer) || adresProfilu(okno);
    };

    // gdy adresy dojda po udekorowaniu okien, podmieniamy same odnosniki
    const odswiezAdresy = () => {
      udekorowane.forEach((okno) => {
        const adres = adresDlaOkna(okno);
        if (!adres) return;
        okno.querySelectorAll("[data-cossy-post-href]").forEach((element) => {
          element.setAttribute("href", adres);
        });
      });
    };

    const udekoruj = (okno) => {
      if (okno.dataset[ZNACZNIK]) return;
      okno.dataset[ZNACZNIK] = "1";

      const adres = adresDlaOkna(okno);
      if (!adres) return;
      udekorowane.push(okno);

      const napis = etykieta();

      // 1. cale zdjecie klikalne - warstwa NAD obrazkiem, bo aplikacja
      //    wygasza mu zdarzenia myszy
      const zdjecie = okno.querySelector(".instafeed-post-image");
      if (zdjecie && !zdjecie.querySelector(".instafeed-post-open")) {
        const warstwa = document.createElement("a");
        warstwa.className = "instafeed-post-open";
        warstwa.href = adres;
        warstwa.target = "_blank";
        warstwa.rel = "noopener nofollow";
        warstwa.setAttribute("data-cossy-post-href", "1");
        if (napis) warstwa.setAttribute("aria-label", napis);
        zdjecie.appendChild(warstwa);
      }

      // 2. przycisk w kolumnie z opisem, nad data wpisu
      const opis = okno.querySelector(".description");
      if (napis && opis && !opis.querySelector(".instafeed-post-cta")) {
        const przycisk = document.createElement("a");
        przycisk.className = "btn-primary instafeed-post-cta";
        przycisk.href = adres;
        przycisk.target = "_blank";
        przycisk.rel = "noopener nofollow";
        przycisk.setAttribute("data-cossy-post-href", "1");
        przycisk.textContent = napis;

        const data = opis.querySelector(".post-date");
        if (data) opis.insertBefore(przycisk, data);
        else opis.appendChild(przycisk);
      }
    };

    const przejrzyj = () => {
      const okna = document.querySelectorAll(".instafeed-lightbox");
      okna.forEach(udekoruj);
      return okna.length > 0;
    };

    const start = async () => {
      if (adresyWpisow.size === 0) {
        const udalo = await pobierzAdresy();
        if (udalo) odswiezAdresy();
      }
      przejrzyj();
    };

    // aplikacja zglasza gotowosc wlasnym zdarzeniem na dokumencie
    document.addEventListener("instafeedAppLoaded", start);

    // zabezpieczenie, gdy zdarzenie poszlo przed wczytaniem tego pliku:
    // kilka podejsc, a potem koniec - bez petli w tle
    let podejscia = 0;
    const zegar = setInterval(() => {
      podejscia += 1;
      if (przejrzyj() && adresyWpisow.size > 0) clearInterval(zegar);
      else if (podejscia === 1 || adresyWpisow.size === 0) start();
      if (podejscia >= 20) clearInterval(zegar);
    }, 700);

    start();
  })();
}
